// extracted by mini-css-extract-plugin
export default {"button":"button___a882e9f74f25a78d6111"};